import React, {useState} from 'react';
import {StyledCopyIcon} from './styles';
import {CopyButtonProps} from './types';
import {Snackbar} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';

const {copyNumber} = translations['pt-br'].privateFlow.healthCard;

export function CopyButton({value, iconSize}: CopyButtonProps) {
	const {isMobile} = useMediaQueries();
	const [copied, setCopied] = useState(false);

	const handleCopy = async () => {
		if (copied) return;
		await navigator.clipboard.writeText(value);
		setCopied(true);
		setTimeout(() => setCopied(false), 3000);
	};

	return (
		<>
			<StyledCopyIcon
				name={copied ? 'success' : 'content-copy-filled'}
				onClick={handleCopy}
				$copied={copied}
				size={iconSize}
			/>
			<Snackbar
				open={copied}
				message={copyNumber}
				sx={{marginBottom: isMobile ? '120px' : ''}}
			/>
		</>
	);
}
